module.exports = __webpack_public_path__ + "static/gypsyhub-logo-white-bb9f1bfdc6cd3ee995e8451c678a0a8e.png";